export const AGENT_VIEWS_TYPES = {
  compactRow: 'Compact Row',
  standardRow: 'Standard Row',
};
